import { Chip, Stack } from '@mui/material'
import React from 'react'

import { Value } from 'components/attacks/details/AttackStyles'
import ChipList from 'components/common/ChipList'

export const TagsDisplay: React.FC<{
  multiValueMap?: {
    [key: string]: string[]
  }
}> = ({ multiValueMap }) => {
  if (!multiValueMap || Object.entries(multiValueMap).length === 0) {
    return null
  }

  return (
    <Stack direction="column" spacing={1}>
      {Object.keys(multiValueMap).map((label) => (
        <Value key={label} data-test-tags-display-label={label}>
          {label}
          <ChipList>
            {multiValueMap[label].map((value) => {
              return (
                <Chip
                  key={value}
                  data-test-tags-display-chip={value}
                  label={value}
                />
              )
            })}
          </ChipList>
        </Value>
      ))}
    </Stack>
  )
}
